import styled from 'styled-components';
import backgroundUrl from '../../stories/assets/Splash.jpg';

export const StyledBackground = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url('${backgroundUrl}');
  z-index: -1;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
